module.exports = __webpack_public_path__ + "/robots.txt";